module.exports = "https://milano-network.servercdn.it/static/img/next.svg?76cefc8f53f70878af1e2557ac3b9466";